import React, { useState } from "react";
import "../css/Gallery.css";

const Gallery = () => {
  const [filter, setFilter] = useState("all");

  const images = [
    { category: "gym", url: "https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg" },
    { category: "gym", url: "https://images.unsplash.com/photo-1558611848-73f7eb4001a1?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "gym", url: "https://images.unsplash.com/photo-1623874106686-5be2b325c8f1?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "gym", url: "https://images.unsplash.com/photo-1689877020200-403d8542d95d?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "equipment", url: "https://images.unsplash.com/photo-1578874691223-64558a3ca096?q=80&w=735&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "equipment", url: "https://images.unsplash.com/photo-1544033527-b192daee1f5b?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "equipment", url: "https://images.unsplash.com/photo-1589955898954-9c8d4bb86823?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "members", url: "https://images.unsplash.com/photo-1711438645294-3a6783642ebb?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "members", url: "https://images.unsplash.com/photo-1603698819488-03c6e857d280?q=80&w=765&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "members", url: "https://images.unsplash.com/photo-1710253705023-c5c6445c9fad?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "members", url: "https://images.unsplash.com/photo-1610211882472-eece2574cad9?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "members", url: "https://images.unsplash.com/photo-1614367674345-f414b2be3e5b?q=80&w=686&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "gym", url: "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?q=80&w=1375&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "classes", url: "https://images.unsplash.com/photo-1517130038641-a774d04afb3c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "classes", url: "https://images.unsplash.com/photo-1593358578736-186f3d13c789?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "classes", url: "https://images.unsplash.com/photo-1549995546-87cb41aa98a4?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "classes", url: "https://images.unsplash.com/photo-1614928228253-dc09cbc3b11c?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "classes", url: "https://images.unsplash.com/photo-1671581084718-c4c04fc00250?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "classes", url: "https://images.unsplash.com/photo-1554284126-aa88f22d8b74?q=80&w=1294&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
    { category: "gym", url: "https://images.unsplash.com/photo-1637430308606-86576d8fef3c?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
  ];

  const categories = [
    { id: "all", label: "ALL" },
    { id: "gym", label: "GYM" },
    { id: "equipment", label: "EQUIPMENT" },
    { id: "members", label: "MEMBERS" },
    { id: "classes", label: "CLASSES" },
  ];

  const filtered = filter === "all" ? images : images.filter(img => img.category === filter);

  return (
    <div className="gallery-page">

      {/* HERO */}
      <section className="gallery-hero">
        <h1>GALLERY</h1>
        <p>Experience the ACE environment — raw, powerful, relentless.</p>
        <span className="red-line"></span>
      </section>

      {/* FILTERS */}
      <section className="gallery-filters">
        {categories.map(cat => (
          <button
            key={cat.id}
            className={filter === cat.id ? "active" : ""}
            onClick={() => setFilter(cat.id)}
          >
            {cat.label}
          </button>
        ))}
      </section>

      {/* MASONRY GRID */}
      <section className="gallery-grid">
        {filtered.map((img, i) => (
          <div key={i} className="gallery-item">
            <img src={img.url} alt="Gallery" />
            <div className="overlay"></div>
          </div>
        ))}
      </section>

      {/* CTA */}
      <section className="gallery-cta">
        <h1>THE JOURNEY STARTS HERE.</h1>
        <button>Join ACE Fitness</button>
      </section>

    </div>
  );
};

export default Gallery;
